import { MuiThemeProvider, TextField } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { IShortageTimer } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ColorPicker from './ColorPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IShortageTimer;
}

@WithStyles(() => ({
  buttonText: {
    marginTop: 16,
    width: '100%'
  },
  labelSwitch: {
    fontWeight: 'bold',
    color: '#596375'
  }
}))
export default class ShortageTimer extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(model => model.shortageTimer)
      )
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeBackground = (color: string) => {
    const bgColor = `${color.substr(0, color.length - 2)} 0.8)`;

    themeCustomizerService.setData({
      shortageTimer: {
        ...this.state.model,
        bgColor
      }
    });
  };

  onChangeFontColor = (color: string) => {
    themeCustomizerService.setData({
      shortageTimer: {
        ...this.state.model,
        font: {
          ...this.state.model.font,
          color
        }
      }
    });
  };

  onChangeMessage = (event: React.ChangeEvent<HTMLInputElement>) => {
    themeCustomizerService.setData({
      shortageTimer: {
        ...this.state.model,
        message: event.target.value
      }
    });
  };

  onChangeCountTimer = (event: React.ChangeEvent<HTMLInputElement>) => {
    let countTime = Number(event.target.value);

    if (Number(event.target.value) <= 0) {
      countTime = 1;
    }

    if (Number(event.target.value) > 59) {
      countTime = 59;
    }

    themeCustomizerService.setData({
      shortageTimer: {
        ...this.state.model,
        countTime
      }
    });
  };

  onChangeIsActive = (event: React.ChangeEvent<HTMLInputElement>) => {
    themeCustomizerService.setData({
      shortageTimer: {
        ...this.state.model,
        isActive: event.target.checked
      }
    });
  };

  render() {
    const { classes } = this.props;
    const { model } = this.state;

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <FormControlLabel
          control={
            <Switch
              disableRipple
              checked={model.isActive}
              onChange={this.onChangeIsActive}
              value={`${model.isActive}`}
            />
          }
          classes={{ label: classes.labelSwitch }}
          label="Usar timer de escassez"
        />
        <TextField
          id="count-timer"
          label="Tempo de Contagem em Minutos"
          type="number"
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            disableUnderline: true,
            className: classes.input
          }}
          inputProps={{
            min: 1,
            max: 59
          }}
          fullWidth
          value={model.countTime}
          margin="normal"
          onChange={this.onChangeCountTimer}
        />
        <TextField
          id="message"
          label="Mensagem no Final da Contagem"
          fullWidth
          multiline
          rows="4"
          rowsMax="4"
          value={model.message}
          onChange={this.onChangeMessage}
          margin="normal"
          InputProps={{
            disableUnderline: true
          }}
          inputProps={{
            maxlength: 65
          }}
        />
        <ColorPicker value={model.bgColor} label="Cor do Fundo" handleChangeColor={this.onChangeBackground} RGBFormat />
        <ColorPicker label="Cor das Letras" value={model.font.color} handleChangeColor={this.onChangeFontColor} />
      </MuiThemeProvider>
    );
  }
}
